import React, {Component, Fragment} from "react";

import {Paper,
    Grid,
    Typography,
    Button} from "@material-ui/core";

import {Engine} from "@babylonjs/core/Engines/engine";

import {useTranslation, withTranslation} from "react-i18next";

import PackScene from "./create";
import {MergeType} from "@material-ui/icons";


export class Viewer3D extends Component {
    constructor(props, context) {
        super(props, context);
        var state= {
            maxContainer: 1,
            maxLevel: 1,
            fullscreen: false
            };
        this.engine=null;
        this.packScene= null;
        this.scene=null;
        this.state=state;
        this.myRef=React.createRef();
        }

    componentDidMount = () =>  {
        var mydiv = document.getElementById("sceneCanvas");
        if (mydiv.addEventListener) {
            mydiv.addEventListener("wheel", this.WheelHandler, false);
            }
        }

    WheelHandler = (e) => {
        console.log("WheelHandler", e);
        e.preventDefault();
        e.stopPropagation();
        }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!this.state.fullscreen) {
            this.redraw();
            }
        }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return !this.state.fullscreen;
        }

    componentWillUnmount() {

        if (this.packScene) {
            var thisScene = this.packScene;
            this.packScene = null;
            thisScene.dispose();
            var thisEngine = this.engine;
            this.engine = null;
            try {
                thisEngine.dispose();
            } catch (e) {}
            }
        }

    redraw = () => {

        var canvas = this.myRef.current;

        if (canvas) {
            var dspSolution = this.props.solution;
            var dspContainers = this.props.containers;

            if (!this.engine) {

                this.engine = new Engine(canvas, true, {preserveDrawingBuffer: true, stencil: true});

                window.addEventListener("resize",() => {
                    if (this.engine) {
                        this.engine.resize();
                        }
                    });

                this.engine.runRenderLoop( ()  => {
                    if (this.packScene) {
                        this.packScene.render();
                        }
                    });
                }

            if (!this.packScene) {
                this.packScene = new PackScene(this.engine, canvas, this.setFullscreen, this.props.t);
                }

            if (dspSolution && dspContainers) {
                this.packScene.updateScene(dspSolution, dspContainers);
                }
            } else {
            console.log("No canvas");
            }
        }

    toGlb = () => {
        this.packScene.toGlb(this.redraw);
        }

    setFullscreen = (newVal) => {
        if (this.props.setFullscreen) {
            this.props.setFullscreen(newVal);
            }
        this.state.fullscreen = newVal;

        }

    render = () => {

        var {setViewer} = this.props;

        if (setViewer) {
            setViewer(this);
            }

        window.setTimeout(() => {
            this.redraw();
            },
            200);

        return <canvas id="sceneCanvas" ref={this.myRef} style={{width: "97%", height: this.props.height}} />;
        }
    }

Viewer3D = withTranslation() (Viewer3D);

class Result extends Component {
    constructor(props, context) {
        super(props, context);
        }

    toGlb = () => {
        this.viewer.toGlb();
        }

    setViewer = (viewer) => {
        this.viewer = viewer;
        }

    render = () => {

        return <Paper>
            <Grid container>
                <Grid item xs={10}>
                    <Viewer3D setViewer={this.setViewer} {...this.props} />
                </Grid>
                <Grid item xs={2}>
                    <SaveResult saveResult={this.toGlb} {...this.props} />
                </Grid>
            </Grid>
        </Paper>;
        }
    }

export class SaveResult extends Component {
    saveResult = () => {
        return this.props.saveResult();
        }

    onCancel = (e) => {

        this.props.root.cancelRequest();
        }

    render = () => {

        const {t, viewerUrl, apiUrl, root} = this.props;

        return <Fragment>
            <Typography variant="h6">{t("Solve Request")}</Typography>
            <Typography variant="body2">{t("Time")}: <spane id="showTime" /></Typography>
            <Typography variant="body2">{t("Summary")}: {root.state.summary}</Typography>
            <p></p>

            {(!root.state.solveActive) ||
                <Button variant={"contained"} onClick={this.onCancel} color={"secondary"}>{t("Cancel")}</Button>
                }
            {(root.state.solveActive) ||
                <Button variant={"contained"} onClick={root.onSolve} color={"primary"}>{t("Solve")}</Button>
                }
            <p></p>

            <Typography variant="h6">{t("Save Result")}</Typography>
            <Typography variant="body2">{t("GLB files can be viewed with the 3D Viewer included in Windows 10/11.")}</Typography>
            <p></p>
            <Button variant="contained" onClick={this.saveResult} color="primary">{t("GLB")}</Button>
            <p></p>

            { (viewerUrl == null) ||
                <Fragment>
                <Typography variant="h6">{t("Solution URL")}</Typography>
                <Typography variant="body2">{t("There is also an IFRAME embeddable temporary URL ")}
                <a href={viewerUrl} target="3DSolution">{viewerUrl}</a>.</Typography>

                </Fragment>
                }

           {(!root.state.dangerous) ||
                <Fragment>
                    <p></p>
                   <Typography variant="h6">{t("Risk Types")}</Typography>
                    <Typography variant="body2">{t("Risk types are integers. They can be set in the items separated with a comma")}</Typography>

                </Fragment>
                }

        </Fragment>;
        }
    }
SaveResult = withTranslation()(SaveResult);

export default Result;